import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BillingPaymentModal, PaymentResponses } from './payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentModalService {
  constructor(private http: HttpClient) {}

  public makeBillingPayment(data: BillingPaymentModal) {
    return this.http.post<PaymentResponses>('api/Stripe/CapturePayment', data);
  }
}
